<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import ScrollRow from "../ScrollRow.vue";
import { OUTPUTS } from "@/store/modules/output";
import ShapePicker from "@/components/inputs/ShapePicker.vue";

const store = useStore();

const activeOutput = computed(() => store.state.output.activeOutput);
const selectOutput = (output) => store.dispatch("output/selectOutput", output);
</script>

<template>
  <section id="shepherd-target-output">
    <div class="mb-6 flex flex-col lg:mb-8">
      <p class="mb-1 text-base font-bold text-primary">Output</p>
      <p class="mb-4 text-sm text-secondary">
        Get your make as a file to download, or let Auto pick what suits it.
      </p>
      <ScrollRow>
        <button
          v-for="option in OUTPUTS"
          :key="option.id"
          type="button"
          :class="
            activeOutput === option.id
              ? 'bg-accentSecondary text-primary'
              : 'bg-gray-10 hover:bg-gray-100 text-secondary'
          "
          class="flex flex-col items-center justify-center w-24 h-24 mr-4 rounded-lg cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-accentPrimary"
          :aria-pressed="activeOutput === option.id"
          @click="selectOutput(option.id)"
        >
          <font-awesome-icon class="text-2xl" :icon="['fas', option.icon]" />
          <span class="mt-2 text-sm text-center">{{ option.label }}</span>
        </button>
      </ScrollRow>
      <div v-if="activeOutput === 'image'" class="mt-4">
        <p class="mb-2 text-sm font-bold text-primary">Shape</p>
        <ShapePicker />
        <p class="mt-2 text-xs text-secondary">
          An image uses 3 wishes, and each new version 2 more.
        </p>
      </div>
    </div>
  </section>
</template>
